import { useState } from 'react';

import useAPI from "../../../../hooks/useAPI";

export const LISTAR_FILTERS = {
  SEARCH: 'search'
}

const buildListarV2Url = ({ baseUrl, page, rowsPerPage, filters }) => {
  const query = {
    page: page + 1,
    limit: rowsPerPage,
    ...(filters?.[LISTAR_FILTERS.SEARCH] && {search: filters[LISTAR_FILTERS.SEARCH]})
  }

  const queryParams = new URLSearchParams(query);

  return `${baseUrl}?${queryParams.toString()}`;
}

export default function useListarV2() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filters, setFilters] = useState({});

  const { data, isLoading, refreshData } = useAPI(buildListarV2Url({ baseUrl: '/admin/incompany/v3/trails', page, rowsPerPage, filters }));

  const changePage = (newPage) => {
    setPage(newPage);
  }

  const changeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    changePage(0);
  }

  const changeFilters = (newFilters) => {
    setFilters(newFilters);
    changePage(0);
  }

  const resetFilters = () => {
    changeFilters({});
  }
  
  return {
    data,
    isLoading,
    page,
    rowsPerPage,
    filters,
    refreshData,
    changePage,
    changeRowsPerPage,
    changeFilters,
    resetFilters
  };
}